import { render } from "./MapView.vue?vue&type=template&id=b2623cdc&scoped=true"
import script from "./MapView.vue?vue&type=script&lang=js"
export * from "./MapView.vue?vue&type=script&lang=js"

import "./MapView.vue?vue&type=style&index=0&id=b2623cdc&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2623cdc"]])

export default __exports__